namespace advisorop.components.common {

    class SelectCuHouseholdController {
        households: Array<domains.IHousehold> = [];
        investor: domains.IInvestor;
        isVisibleCUHouseholdForm: boolean = false;
        showCuPanel: string = "1";
        selHousehold: domains.IHousehold;
        householdName: string;
        advisoryFirmId: number;
        onHouseholdSelected: any;
        onHouseholdCu: any;
        onRtgCu: any;

        static $inject = ["advisorService"];
        constructor(public advisorService: services.AdvisorService) {
        }

        selectHousehold(household: domains.IHousehold): void {
            this.selHousehold = household;
            this.householdSelected = !( !this.selHousehold );
            this.onHouseholdSelected({ household: this.selHousehold });
        };

        householdSelected: boolean = false;

        householdChanged(): void {
          
            this.selectHousehold(this.selHousehold);
            this.isVisibleCUHouseholdForm = false;
        };
        
        householdCu(household: domains.IHousehold): void {
            var pos = this.households.map(m => { return m.id }).indexOf(household.id);
            if (pos >= 0) {
                this.households[pos] = household;
            }
            else {
                this.households.push(household);
            };

            this.selectHousehold(household);
        };

        initNewHousehold(): void {
            if (this.householdSelected == true)
                this.householdSelected = false;

            this.isVisibleCUHouseholdForm = !this.isVisibleCUHouseholdForm;

            this.selHousehold = {
                id: 0,
                investors: [],
                rtgs: [],
                name: ""
            };

            this.showCuPanel = "1";
        };


        rtgCu(rtg: domains.IAccountGroup): void {
            //console.log("select-cu-household: onRtgCu...");
            this.onRtgCu({ rtg: rtg });
        };
        
        $onInit(): void {
            if (this.selHousehold && this.selHousehold.id > 0) {
                this.householdSelected = true;
            }

        };

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }                        
            for (var key in evt) {
                if (key === "households" && this.households)
                {
                    this.selHousehold == null;
                    // this.households.filter((v, i, a) => { return v.advisoryFirmId === v.advisoryFirmId })
                   
                    if (this.households.length > 0) {
                        this.selectHousehold(this.households[0]);
                    }
                    else
                        this.selectHousehold(null);
                }
                if (key === "advisoryFirmId") {
                    if (this.advisoryFirmId > 0) {

                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
        };


        rtqSelected(rtq: domains.IRTQ): void {
            //console.log("Event selectCuHousehold.rtqSelected", rtq);
        }
        
        rtqCreated(rtq: domains.IRTQ): void {
            // console.log("Event selectCuHousehold.rtqCreated", rtq);
            if (rtq) {
                toastr.info("RTQ has been successfully completed.");
                let newRtg: domains.IAccountGroup = {
                    id: 0,
                    householdId: this.selHousehold.id,
                    rtq: rtq,
                    rtqId: rtq.id
                };

                // Nov 2018 GL - add this as a fix because inside new-account-wiz when creating new RTG on the fly
                // this was set to null and the next push statement below was failing.
                if (!this.selHousehold.rtgs) {
                    this.selHousehold.rtgs = [];
                }
                this.selHousehold.rtgs.push(newRtg);

                //this.rtgCu(newRtg);
                this.onRtgCu({ rtg: newRtg });
            }

        };
        
        getHousehld(id: number): ng.IPromise<domains.IHousehold> {
            return this.advisorService.getHousehold(id)
                .then((data) => {
                    this.selHousehold = data.data;
                    return data.data;
                }, err => {
                    toastr.error("Error " + err.status + " " + err.data);
                });
        };

        resetForm(): void {
            this.householdName = "";
            this.isVisibleCUHouseholdForm = false;
        };
    }



    class SelectCuHousehold implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                households: "<",
                advisoryFirmId: "<",
                investor: "<",
                onHouseholdSelected: "&",
                onHouseholdCu: "&",
                onRtgCu: "&",
                showCuPanel: "@"
            };
            this.controller = SelectCuHouseholdController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/select-cu-household.html';
        }
    }
    angular.module(Constants.APP).component("selectCuHousehold", new SelectCuHousehold());


}